import { useStore } from '../api/index.ts';
import {
  type RouteLocationNormalizedGeneric,
  type RouteLocationNormalizedLoadedGeneric,
  type NavigationGuardNext,
} from 'vue-router';
import { setHTMLDarkMode } from '../assets/js/helpers/DarkThemeHelper.ts';

export function redirectRouteTemplate(
  path: string,
  target: string,
  name: string,
) {
  return {
    path,
    name,
    component: () => import('../views/RedirectView.vue'),
    props: {
      target: name,
    },
    meta: {
      layout: 'BasicLayout',
    },
    beforeEnter() {
      window.location.href = target;
    },
  };
}

export function appRouteTemplate({
  path,
  component,
  name,
  title,
}: {
  path: string;
  component: any;
  name: string;
  title?: string;
}) {
  return {
    path,
    name,
    component,
    meta: {
      authRequired: true,
      layout: 'AppLayout',
      title,
    },
    beforeEnter: (
      to: RouteLocationNormalizedGeneric,
      from: RouteLocationNormalizedLoadedGeneric,
      next: NavigationGuardNext,
    ) => {
      const store = useStore();
      setHTMLDarkMode(store.userPreferences.darkMode);
      next();
    },
  };
}
